import { DEFAULT_ZOOM_FACTOR } from './constants';
import getZoomFitFactor from './getZoomFitFactor';

export const CANVAS_ZOOM_STEP_MULTIPLIER = 1.1;

export const getCanvasFitZoomFactor = ({
  resize = {},
  crop = {},
  shownImageDimensions = {},
}) => {
  const usedAsOrgDimens =
    (resize.width && resize.height && resize) ||
    (crop.width && crop.height && crop) ||
    shownImageDimensions;

  return (
    getZoomFitFactor(
      (crop.width && crop.height && crop) || shownImageDimensions,
      usedAsOrgDimens,
    ) || DEFAULT_ZOOM_FACTOR
  );
};

export const getCanvasPresetZoomFactor = ({
  presetFactor,
  originalImage,
  shownImageDimensions = {},
}) => {
  if (!originalImage?.width || !shownImageDimensions?.width) {
    return null;
  }

  return Math.min(
    (presetFactor * originalImage.width) / shownImageDimensions.width,
    (presetFactor * originalImage.height) / shownImageDimensions.height,
  );
};
